import { API_URL } from "../../constants";

export const isExternalLink = (link: string, location: { host: string, protocol: string } = window.location, includeApi?: boolean): boolean => {
    const { host, protocol } = location;
    try {
        const url = new URL(link, `${protocol}//${host}`);
        return url.host !== host || (url.pathname.startsWith(API_URL) && !includeApi);
    } catch (e) {
        return true;
    }
};

// Todo: maybe if we need this in the future? We would need to also exclude Evala pages domains, e.g. www.evala.cz, etc...
//  Needs to be enhanced. Consider also check of base subdomains depth, because locally there is configured
//  e.g. e2e.local.evaladevel.net, so the depth to check is 3 instead of 2.
// export const isEvalaAppLink = (link: string, location: { host: string, protocol: string } = window.location): boolean => {
//     const { host, protocol } = location;
//     try {
//         const url = new URL(link, `${protocol}//${host}`);
//         // check if different only in first subdomain, e.g. app.evala.cz and tenant.evala.cz should be considered as internal link
//         const [linkHost, currentHost] = [url.host, host].map(h => h.split(".").slice(-2).join("."));
//         const isDifferentHost = linkHost !== currentHost;
//         return isDifferentHost || (url.pathname.startsWith(API_URL));
//     } catch (e) {
//         return true;
//     }
// };